import { createPortal } from "react-dom";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function FollowUpStatusModal({
  isOpen,
  onClose,
  onConfirm,
  statusType,
}) {
  const { t } = useTranslation();
  const [note, setNote] = useState("");

  useEffect(() => {
    if (!isOpen) setNote("");
  }, [isOpen]);

  if (!isOpen) return null;

  const title =
    statusType === 3
      ? t("followUps.cancelFollowUpTitle")
      : t("followUps.completeFollowUpTitle");

  const placeholder =
    statusType === 3
      ? t("followUps.cancelReasonPlaceholder")
      : t("followUps.completionNotePlaceholder");

  const confirmText =
    statusType === 3
      ? t("followUps.confirmCancel")
      : t("followUps.confirmComplete");

  return createPortal(
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] text-primary">
      <div className="bg-white p-6 rounded shadow w-full max-w-[30%]">
        <h3 className="font-bold text-lg mb-4">{title}</h3>

        <textarea
          className="textarea textarea-bordered w-full h-24"
          placeholder={placeholder}
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />

        <div className="flex justify-end space-x-2 mt-4">
          <button
            className="rounded-full border border-primary px-4 py-2"
            onClick={onClose}
          >
            {t("global.cancel")}
          </button>
          <button
            className="rounded-full border bg-red-500 text-white px-4 py-2"
            onClick={() => {
              if (!note.trim()) {
                alert(t("followUps.noteRequired"));
                return;
              }
              onConfirm(note);
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
